// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3unVa","field":"styles_field__3QpKy","fieldCol":"styles_fieldCol__WD-99","diffCol":"styles_diffCol__2FhxS","diff":"styles_diff__aF2JI"};